import {gql} from '@apollo/client';
import {POT} from '../graphql/fragments';

export const LIST_POTS = gql`
  ${POT}
  query ListPots(
    $accountId: UUID!
    $contactId: UUID
    $parentOnly: Boolean
    $banksOnly: Boolean
    $curoSync: Boolean!
  ) {
    pots(
      accountId: $accountId
      curoSync: $curoSync
      contactId: $contactId
      parentOnly: $parentOnly
      banksOnly: $banksOnly
    ) {
      ...Pot
    }
  }
`;

export const LIST_SOURCES_DESTINATIONS = gql`
  ${POT}
  query RequirementPots(
    $accountId: UUID!
    $contactId: UUID
    $reviewId: UUID
    $potType: String
    $planAction: String
    $curoSync: Boolean!
  ) {
    sources: requirementPots(
      accountId: $accountId
      contactId: $contactId
      curoSync: $curoSync
      reviewId: $reviewId
      isSource: true
      potType: $potType
      planAction: $planAction
    ) {
      ...Pot
    }
    destinations: requirementPots(
      accountId: $accountId
      contactId: $contactId
      curoSync: $curoSync
      reviewId: $reviewId
      isSource: false
      potType: $potType
      planAction: $planAction
    ) {
      ...Pot
    }
  }
`;

export const PROTECTION_POT = gql`
  fragment ProtectionPot on PotType {
    id
    curoId
    name
    isDeleted
    inTrust
    protectionType
    livesAssured
    premiumType
    lifeCover
    terminatingAge
    criticalIllnessCover
    lifeOrCriticalIllnessCover
    termType
    term
    indexation
    benefitBasis
    benefitBasisMonthlyText
    deferredPeriod
    notes
    investmentLinked
    monthlyIncome
    waiverOfPremium
  }
`;

export const DELETE_POT = gql`
  mutation DeletePot($potId: UUID!) {
    deletePot(potId: $potId) {
      ok
      potId
    }
  }
`;
